import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vendorEntityStatus'
})
export class VendorEntityStatusPipe implements PipeTransform {

  private map: Record<string, { label: string; class: string }> = {
    unverified:       { label: 'Draft',              class: 'chip-vendor-unverified' },
    pending:          { label: 'Awaiting Approval',  class: 'chip-vendor-pending' },
    approved:         { label: 'Approved',           class: 'chip-vendor-approved' },
    verified:         { label: 'Verified',           class: 'chip-vendor-verified' },
    verified_pending: { label: 'Pending Changes',    class: 'chip-vendor-pending-changes' },
    blacklisted:      { label: 'Blacklisted',        class: 'chip-vendor-blacklisted' },
  };

  transform(value: string, type: 'label' | 'class', hasPendingChanges: boolean = false): string {
    const key = value === 'verified' && hasPendingChanges ? 'verified_pending' : value;
    return this.map[key]?.[type] ?? '';
  }

}
